module.exports = __webpack_public_path__ + "static/media/ms-doc-file.ffeb16b0.png";